import React from "react";
import JudgmentArrow from "../../assets/icons/judgment-arrow.svg";
import {
  getInspectionResutlColor,
  getInspectionResutlBackground,
  getInspectionResutlSymbol,
} from "../../utils/display-utils";
import { useSelector } from "react-redux";
import { Button } from "../../components";
import { formatDate } from "../../utils/datetime-utils";
import { JUDGMENT } from "../../constants/routes";
import { useNavigate } from "react-router-dom";

const JudgmentStatusInModal = ({
  className,
  judgmentStatus,
  inspectionId,
  workflowId,
  workflowName,
}) => {
  const resultSymbolSetting = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_symbol
  );
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate(`${JUDGMENT}?inspection=${inspectionId}&workflow=${workflowId}`);
  };

  const maxWidth = judgmentStatus?.length * 160 + 1;

  return (
    judgmentStatus && (
      <div
        className={`bg-white border-b border-t border-tenken-gray-500 w-fit ${className}`}
      >
        <div
          style={{ maxWidth: `${maxWidth}px` }}
          className="p-1 text-center border-x border-tenken-gray-500 bg-tenken-gray-300 truncate"
        >
          <span title={workflowName}>{workflowName}</span>
        </div>
        <div className="flex border-t border-r border-tenken-gray-500 overflow-x-auto overflow-y-hidden">
          {judgmentStatus &&
            judgmentStatus?.map((judgment) => (
              <div className="flex gap-0">
                <div className="w-[160px] border-l border-tenken-gray-500">
                  <div className="w-full max-w-[160px] p-[4px] text-center bg-tenken-gray-300 border-b border-tenken-gray-500 truncate">
                    <span title={judgment.incharge_name}>
                      {judgment.incharge_name}
                    </span>
                  </div>
                  <div className="h-[160px] px-[24px] pt-[10px] pb-[20px]">
                    <div className="w-full flex justify-center items-center h-[60px]">
                      {judgment.result === 1 && (
                        <div>
                          <img src={JudgmentArrow} alt="judged" />
                        </div>
                      )}
                    </div>
                    {!judgment.can_rejudgment &&
                      !judgment.can_rejudgment &&
                      judgment.result >= 0 && (
                        <div className="mt-[10px] flex justify-center">
                          <div
                            className="px-auto py-1 w-10"
                            style={{
                              color: getInspectionResutlColor(
                                judgment?.result,
                                resultSymbolSetting
                              ),
                              background: getInspectionResutlBackground(
                                judgment?.result,
                                resultSymbolSetting
                              ),
                            }}
                          >
                            <span className="flex justify-center items-center">
                              {getInspectionResutlSymbol(
                                judgment.result,
                                resultSymbolSetting
                              )}
                            </span>
                          </div>
                          <span className="ml-1 py-1">
                            {judgment.result === 1 ? "承認" : "差し戻し"}
                          </span>
                        </div>
                      )}
                    <div className="w-full flex justify-center items-center">
                      {judgment.can_rejudgment && (
                        <Button
                          color="yellow"
                          className="w-[112px]"
                          onClick={() => handleNavigate()}
                        >
                          再判定
                        </Button>
                      )}
                      {judgment.can_judgment && (
                        <Button
                          color="red"
                          className="w-[112px]"
                          onClick={() => handleNavigate()}
                        >
                          判定
                        </Button>
                      )}
                    </div>
                    <div className="mt-[10px] w-full text-center p-2">
                      {judgment?.judgment_datetime &&
                        formatDate(judgment.judgment_datetime)}
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    )
  );
};

export default JudgmentStatusInModal;
